/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

Dropzone.autoDiscover = false

var Environment = new Class({
  outsideClick: true,
  close: function () {
    var close = $$('.close--button')
    if (close) {
      close.set('title', this.i18n.footer.close.title)
      close.addEvents({
        click: function (e) {
          e.preventDefault()
          this.doClose()
        }.bind(this),
      })
    }
  },
  doClose: function () {
    this.settings_hide()
    this.messageCallback('hide')
    this.userCallback('leave', null, false)
  },
  restart: function () {
    var restart = $('restart')
    if (restart) {
      $('restart--button').set('title', this.i18n.footer.restart.title)
      restart.addEvents({
        click: function (e) {
          e.preventDefault()
          this.doRestart()
        }.bind(this),
      })
    }
  },
  doRestart: function () {
    this.parent.purgeBot(true)
  },
  settings_show: function () {
    $('settings').addClass('show')
  },
  settings_hide: function () {
    $('settings').removeClass('show')
  },
  settings: function () {
    if ($('settings')) {
      var triggers = $('settings').getElements('div, span, label')
      triggers.each(
        function (trigger, i) {
          trigger.addEvents({
            mouseenter: function () {
              this.outsideClick = false
            }.bind(this),
            mouseleave: function () {
              this.outsideClick = true
            }.bind(this),
          })
        }.bind(this)
      )
    }
    if ($('settings--button')) {
      $('settings--button')
        .addEvents({
          click: function (e) {
            e.preventDefault()
            if ($('settings').hasClass('show')) {
              this.settings_hide()
              return
            }
            this.settings_show()
          }.bind(this),
        })
        .set('title', this.i18n.footer.settings.title)
    }
    if ($('botresponds')) {
      $('botrespondsLabel').set('text', this.i18n.footer.settings.botResponds)
      $('botresponds').addEvents({
        change: function (e) {
          setTimeout(
            function () {
              this.settings_hide()
            }.bind(this),
            500
          )
        }.bind(this),
      })
    }
    if ($('botPosition')) {
      $('botPositionLeft').set('text', this.i18n.footer.settings.botPosition.left)
      $('botPositionRight').set('text', this.i18n.footer.settings.botPosition.right)
      $('botPositionCenter').set('text', this.i18n.footer.settings.botPosition.center)
      $('botPositionFullWidth').set('text', this.i18n.footer.settings.botPosition.full_width)

      $('botPosition').addEvents({
        change: function (e) {
          setTimeout(
            function () {
              this.settings_hide()
              this.requestChangePosition(e.target.value)
            }.bind(this),
            500
          )
        }.bind(this),
      })
    }
  },
  isElementInViewport: function (element) {
    var rect = element.getBoundingClientRect()

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  },
  debounce: function (func, wait, immediate) {
    var timeout
    return function () {
      var context = this,
        args = arguments
      var later = function () {
        timeout = null
        if (!immediate) func.apply(context, args)
      }

      var callNow = immediate && !timeout
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
      if (callNow) {
        func.apply(context, args)
      }
    }
  },
  scrollArrows: function () {
    var conversation = $('conversation'),
      scrollArrows = $$('.scroll-arrows'),
      arrowTop = $$('.scroll-arrows__top'),
      arrowBottom = $$('.scroll-arrows__bottom')

    var scrollCallback = function () {
      var scrollHeight = conversation.scrollHeight,
        clientHeight = conversation.clientHeight

      if (scrollHeight > clientHeight) {
        var scrollTop = conversation.scrollTop,
          isActive = scrollArrows[0].hasClass('scroll-arrows_is-active')

        if (!isActive) {
          scrollArrows.addClass('scroll-arrows_is-active')
        }

        arrowTop.toggleClass('is-disabled', scrollTop <= 200)

        arrowBottom.toggleClass('is-disabled', scrollHeight - scrollTop - 100 <= clientHeight)
      } else {
        if (isActive) {
          scrollArrows.removeClass('scroll-arrows_is-active')
        }
      }
    }

    conversation.addEvent('scroll', this.debounce(scrollCallback, 400))

    arrowTop.addEvents({
      click: function () {
        if (!arrowTop[0].hasClass('is-disabled')) {
          var currentOffset = conversation.scrollTop
          var scrollTopArrow = new Fx.Scroll('conversation', {
            offset: {
              x: 0,
              y: currentOffset > 500 ? conversation.scrollTop - 400 : 0,
            },
          }).toTop()
        }
      },
    })

    arrowBottom.addEvents({
      click: function () {
        if (!arrowBottom[0].hasClass('is-disabled')) {
          var currentOffset = conversation.scrollTop
          var scrollTopArrow = new Fx.Scroll('conversation', {
            offset: {
              x: 0,
              y: conversation.scrollTop + 400,
            },
          }).toTop()
        }
      },
    })
  },
  scrollTop: function () {
    var timedEvent,
      oldScrollTop = 0 // to check scroll direction

    $('conversation').addEvents({
      scroll: function () {
        if (!BrowserData.isMobile) {
          // check is mobile or not
          var scrollTop = $('conversation').scrollTop,
            directionTop = oldScrollTop < scrollTop,
            containerHeight = this.app.getSize().y,
            botOffset = this.parent.getBotOption('botOffset')

          if (botOffset && ((botOffset.top && botOffset.top.value) || (botOffset.bottom && botOffset.bottom.value))) {
            clearTimeout(timedEvent) // animation throttling clear

            $('conversation')
              .getChildren()
              .each(
                function (e) {
                  var height = e.getSize().y,
                    maxHeight = height / containerHeight < 0.5, // max height for animation
                    visible = this.isElementInViewport(e) // check if element in viewport

                  timedEvent = setTimeout(function () {
                    // animation throttling

                    if (
                      visible &&
                      maxHeight &&
                      !e.hasClass('previewMode') &&
                      (e.hasClass('bot--bubble') ||
                        e.hasClass('panel--wrapper') ||
                        e.hasClass('answer--bubble') ||
                        e.hasClass('isAnswered'))
                    ) {
                      var diff =
                          !botOffset.top || !botOffset.top.value
                            ? 1
                            : ((e.offsetTop + (directionTop ? height - 40 : height) - scrollTop) / height).toFixed(2), // diff to top edge
                        bottomDiff =
                          !botOffset.bottom || !botOffset.bottom.value || e.offsetTop + height < containerHeight
                            ? 1
                            : (
                                (scrollTop - (e.offsetTop - containerHeight + (directionTop ? 40 - height : 40))) /
                                height
                              ).toFixed(2) // diff to bottom edge

                      if (diff < 1 || bottomDiff < 1) {
                        var value = diff < 1 ? diff : bottomDiff

                        e.setStyles({
                          opacity: value * 0.5,
                          transform:
                            'scale3d(' + (value > 0.6 ? value : 0.6) + ',' + (value > 0.6 ? value : 0.6) + ', 1)',
                        })
                      } else {
                        e.setStyles({
                          opacity: 1,
                          transform: 'scale3d(1,1,1)',
                        })
                      }
                    }
                  }, 100)
                }.bind(this)
              )
            oldScrollTop = scrollTop
          }
        }
      }.bind(this),
    })
  },
  toolbar_show: function () {
    $('toolbar--inner').addClass('show')
  },
  toolbar_hide: function () {
    $('toolbar--inner').removeClass('show')
  },
  toolbar: function () {
    if (this.parent.botOptions.showFooter !== false) {
      $('footer--toolbar').addClass('show')
    }
    $('arrow--icon')
      .addEvents({
        click: function () {
          var recaptcha = $('recaptcha')

          $('toolbar--inner').hasClass('show') ? this.toolbar_hide() : this.toolbar_show()
          if (recaptcha) {
            recaptcha.hasClass('show') ? recaptcha.removeClass('show') : recaptcha.addClass('show')
          }
          this.settings_hide()

          setTimeout(
            function () {
              this.toolbar_hide()
              this.settings_hide()
              this.powered_by_unhover()
              if (recaptcha && recaptcha.hasClass('show')) {
                recaptcha.removeClass('show')
              }
            }.bind(this),
            8000
          )
        }.bind(this),
      })
      .set('title', this.i18n.footer.more.title)
  },
  requestChangePosition: function (pos) {
    this.messageCallback('changePosition', pos)
  },
  requestModal: function (isOpened) {
    this.messageCallback('modal', isOpened)
  },
  powered_by_unhover: function () {
    $('powered--label').removeClass('hover')
  },
  powered_by: function () {
    var powered = $('powered--label')
    powered.set(
      'href',
      (this.parent.botOptions.branding && this.parent.botOptions.branding.url) || this.i18n.branding.url
    )
    $$('.powered--label__text')[0].set(
      'text',
      (this.parent.botOptions.branding && this.parent.botOptions.branding.title) || this.i18n.branding.title
    )

    powered.addEvents({
      touchstart: function (e) {
        if (powered.hasClass('hover')) {
          return true
        } else {
          powered.addClass('hover')
          e.preventDefault()
          return false
        }
      },
    })

    $(document).addEvents({
      touchstart: function (e) {
        if (e.target !== powered) {
          this.powered_by_unhover()
        }
      }.bind(this),
    })
  },
  liveChatUnhover: function () {
    $('liveChat--label').removeClass('hover')
  },
  initialize: function (messageCallback, userCallback, parent) {
    this.app = $('conversation')
    this.inputContainer = $('input--container')
    this.parent = parent
    this.i18n = this.parent.botOptions.i18n
    this.app.addEvents({
      click: function () {
        if (this.outsideClick && ($('settings').hasClass('show') || $('toolbar--inner').hasClass('show'))) {
          this.settings_hide()
          this.toolbar_hide()
        }
      }.bind(this),
    })

    this.messageCallback = messageCallback
    this.userCallback = userCallback
    this.settings()
    this.close()
    this.restart()
    this.toolbar()
    this.powered_by()
    this.scrollTop()

    if (!BrowserData.isMobile) {
      this.scrollArrows()
    }

    // this.info();

    // initialize popup
    window.modal = new tingle.modal({
      closeMethods: ['overlay', 'button', 'escape'],
      beforeOpen: function () {
        this.requestModal(true)
      }.bind(this),
      beforeClose: function () {
        this.requestModal(false)
        return true
      }.bind(this),
    })
  },
})

var RandomId = new Class({
  newRandomId: function () {
    return String(new Date().valueOf() + Math.floor(Math.random() * 10000))
  },
})

var Connection = new Class({
  botOptions: {},
  hasOptions: false,
  waitForOptions: null,
  getBotOptions: function (cb) {
    if (!this.hasOptions) {
      this.waitForOptions = setTimeout(
        function () {
          this.getBotOptions(cb)
        }.bind(this),
        50
      )
      return
    }
    clearTimeout(this.waitForOptions)
    cb(this.botOptions)
  },
  switch: function (use, language) {
    this.connPut('switch', { use: use, language: language })
  },
  getBotOption: function () {
    var _args = this.getBotOption.arguments

    if (!this.hasOptions) {
      return false
    }

    if (_args.length > 1) {
      var _optionData = this.botOptions[_args[0]]

      if (!_optionData) {
        return false
      }

      if (typeOf(_optionData).toLowerCase() == 'array') {
        var _optionResult = _optionData.filter(function (item, i) {
          if (typeOf(item).toLowerCase() == 'object') {
            return item.key == _args[1]
          } else {
            return item == _args[1]
          }
        })

        if (_optionResult.length) {
          return _optionResult[0]
        }
        return false
      }
    }

    return this.botOptions[_args[0]] || false
  },
  setBotOptions: function () {
    var options = this.setBotOptions.arguments[0]
    if (typeOf(options) == 'string') {
      try {
        options = JSON.parse(options)
      } catch (e) {
        console.log(e)
      }
    }

    Object.each(
      options,
      function (val, key) {
        this.botOptions[key] = val
      }.bind(this)
    )
    this.use = this.botOptions.use
    this.hasOptions = true
  },
  connGet: function (Message) {
    var conn = this
    var data, action

    try {
      data = JSON.parse(Message.data)
      action = data.action
    } catch (e) {
      // console.log(e);
      return
    }
    switch (action) {
      case 'newBot':
        conn.setBotOptions(data.options)
        break
      case 'validate':
        conn.validate(data.data.valid, data.data.errors, data.data.responses)
        break
      case 'changePosition':
        conn.changePosition(data.data)
        break
      case 'modal':
        conn.modal(data.data)
        break
      case 'startBot':
        conn.startBot(data.data && data.data.restoreState, data.data && data.data.restoreData)
        break
      case 'goto':
        conn.goto(data.key)
        break
      case 'reload':
        this.isComplete = !data.data ? true : data.data.isComplete
        if (data.data && data.data.use) {
          this.use = data.data.use
        }
        window.location.reload()
        break
      case 'exit':
        this.onExit()
        break
      case 'purge':
        this.purgeBot(data.data)
        break
      case 'api':
        if (conn.connApiCallback[data.data.type]) {
          conn.connApiCallback[data.data.type](data)
        }
        break
      case 'populateValues':
        var cb = conn.populateValuesCallback[data.data.base]
        if (cb) {
          delete conn.populateValuesCallback[data.data.base]
          cb(data.data.result)
        }
        break
      case 'populateURL':
        var cb = conn.populateURLCallback[data.data.url]
        if (cb) {
          delete conn.populateURLCallback[data.data.url]
          cb(data.data.result)
        }
        break
      case 'getStepOptions':
        if (conn.getStepOptionsCallback) {
          conn.getStepOptionsCallback(data.data)
        }
        break
      case 'getStepSettingsScript':
        if (conn.getStepSettingsScriptCallback) {
          conn.getStepSettingsScriptCallback(data.data)
        }
        break
      case 'validateAnswer':
        if (conn.validateAnswerCallback) {
          conn.validateAnswerCallback(data.data)
        }
        break
      case 'finish':
        if (conn.connApiCallback[data.data.type]) {
          conn.connApiCallback[data.data.type](data)
        }
        break
      case 'liveChat':
        if (conn.connApiCallback[data.data.type]) {
          conn.connApiCallback[data.data.type](data)
        }
        break
      case 'foldOutClosed':
        if (conn.foldOutClosedCallback) {
          var callback = conn.foldOutClosedCallback
          conn.foldOutClosedCallback = null
          callback(data)
        }
        break
    }
  },
  foldOutClosedCallback: null,
  populateValuesCallback: {},
  populateValues: function (base, callback) {
    var questionValues = base && base.match(/{%(\d)*%}/gi),
      dynamicValues = base && base.match(/{%([\w.])*%}/gi),
      variableValues = base && base.match(/{{([\w.]\.?)*}}/gi)

    if (!questionValues && !dynamicValues && !variableValues) {
      return callback(base)
    }

    this.populateValuesCallback[base] = callback
    this.connPut('populateValues', base)
  },
  populateURLCallback: {},
  populateURL: function (url, callback) {
    this.populateURLCallback[url] = callback
    this.connPut('populateURL', url)
  },
  getStepOptionsCallback: null,
  getStepOptions: function (script, input, callback) {
    this.getStepOptionsCallback = callback
    this.connPut('getStepOptions', { script: script, input: input })
  },
  getStepSettingsScriptCallback: null,
  getStepSettingsScript: function (script, callback) {
    this.getStepSettingsScriptCallback = callback
    this.connPut('getStepSettingsScript', { script: script })
  },
  validateAnswerCallback: null,
  validateAnswer: function (script, answer, callback) {
    this.validateAnswerCallback = callback
    this.connPut('validateAnswer', { script: script, answer: answer })
  },
  connApiCallback: {},
  connPut: function (action, data, apiCallback) {
    var MessageContents = false

    if (apiCallback) {
      this.connApiCallback[data.type] = apiCallback
    }

    if (typeof action === 'object') {
      data = action.data
      action = action.action
    }

    switch (action) {
      case 'change': {
        if (data.what === 'avatar') {
          this.changeAvatar(data.to)
        }
        MessageContents = { action: action, what: data.what, to: data.to }
        break
      }
      case 'execute':
        MessageContents = { action: action, script: data.script }
        break
      default:
        MessageContents = { action: action, data: data }
    }

    if (MessageContents) {
      parent.postMessage(JSON.stringify(MessageContents), '*')
    }
  },
  connEvents: function () {
    var conn = this
    var push = function (Message) {
      conn.connGet(Message)
    }

    try {
      var lstn = window.addEventListener('message', push, false)
      conn.connPut('botIsReady')
    } catch (e) {
      console.log(e)
    }
  },
  newConnection: function () {
    this.connEvents()
  },
})

var View = new Class({
  viewState: [],
  viewScroll: null,
  viewWait: null,
  viewPosition: 20,
  makeScroll: function () {
    return new Fx.Scroll(this.app, {
      duration: 500,
      wait: false,
      transition: Fx.Transitions.Cubic.easeIn,
    })
  },
  setViewPosition: function (forced) {
    if (forced) {
      this.viewScroll = this.makeScroll().toBottom()
    } else {
      var newElement = $(this.viewState.getLast())
      this.gotoViewPosition(newElement)
    }
  },
  gotoViewPosition: function (newElement) {
    if (newElement) {
      var beforeSize = $('before').getSize().y,
        appSize = this.app.getSize().y - beforeSize,
        appScroll = this.app.getScroll().y,
        distance = appSize > appScroll ? appScroll : appSize
      var input = $('input--container').getChildren()[0]
      var inputHeight = input ? input.getSize().y : 0
      var newViewPosition = Math.round(
        newElement.getPosition().y - beforeSize + inputHeight + appScroll + newElement.getSize().y / 10
      )
      if (inputHeight) {
        newViewPosition = this.viewPosition
      }
      // If viewPosition more than appSize
      // means that user did `redo` and position of current view isn't relevant
      if (this.viewPosition - distance > appSize) {
        this.viewPosition = newViewPosition
      }
      if (newViewPosition >= this.viewPosition) {
        if (this.viewScroll) {
          this.viewScroll.stop()
        }

        this.viewPosition = newViewPosition + 10
        this.viewScroll = this.makeScroll().start(0, this.viewPosition)
      } else {
        return
      }
    } else {
      return
    }
  },
  setViewState: function (id) {
    if (this.viewState.indexOf(id) < 0 || !this.viewState.length) {
      this.viewState.push(id)
      this.setViewPosition()
      return
    }
  },
  purgeView: function () {
    this.viewState = []
    this.viewPosition = 20
  },
  view: function (id, pre) {
    if (id && !pre) {
      this.setViewState(id)
    }
  },
})

var Questions = new Class({
  _Questions: [],
  setQuestions: function (questions) {
    questions.each(
      function (obj, i) {
        this._Questions.push(obj)
      }.bind(this)
    )
  },
  getQuestion: function (key) {
    var savedAnswers = this.getBotOption('savedAnswers')

    if (savedAnswers) {
      var saved = savedAnswers.filter(function (s) {
        return s.key == key
      })
    } else {
      var saved = []
    }

    if (this.startedValidation) {
      answer = this.getAnswer(key, 'value')
      if (typeof answer !== 'undefined') {
        saved = [{ value: answer, render: false }]
      }
    }

    var q = this._Questions.filter(
      function (question, i) {
        question.question_index = i + 1
        question.question_total = this._Questions.length
        question.question_saved = false
        return question.key == key
      }.bind(this)
    )

    if (q[0] && saved.length) {
      q[0].question_saved = saved[0]
    }
    return q.length ? q : []
  },
  getQuestionOther: function (question) {
    if (question.options.length && question.other) {
      return question.options.getLast().id
    }
    return false
  },
  getQuestionType: function (type) {
    var questionTypes = {
      0: { name: 'longtext', use: 'text', type: 'string' },
      1: { name: 'shorttext', use: 'text', type: 'string' },
      2: { name: 'yesno', use: 'yesno' },
      3: { name: 'images', use: 'images' },
      4: { name: 'options', use: 'options' },
      6: { name: 'select', use: 'options' },
      7: { name: 'external_chat', use: 'external_chat' },
      8: { name: 'datetime', use: 'datetime' },
      9: { name: 'email', use: 'text', type: 'string' },
      10: { name: 'rating', use: 'rating' },
      11: { name: 'number', use: 'text' },
      12: { name: 'phone', use: 'text', type: 'string' },
      13: { name: 'iban', use: 'text', type: 'string' },
      14: { name: 'items', use: 'autocomplete' },
      15: { name: 'location', use: 'location', type: 'string' },
      16: { name: 'nickname', use: 'text', type: 'string' },
      18: { name: 'datetime_range', use: 'datetime' },
      19: { name: 'birthdate', use: 'datetime' },
      52: { name: 'time', use: 'datetime', type: 'string' },
      22: { name: 'yesno_display', use: 'yesno' },
      222: { name: 'legal', use: 'legal' },
      23: { name: 'text_autocomplete', use: 'text_autocomplete' },
      101: { name: 'start', use: 'button' },
      42: { name: 'end', use: 'button' },
      43: { name: 'button', use: 'button' },
      44: { name: 'again', use: 'again' },
      45: { name: 'file', use: 'file' },
      46: { name: 'name', use: 'text', type: 'string' },
      47: { name: 'first_name', use: 'text', type: 'string' },
      48: { name: 'last_name', use: 'text', type: 'string' },
      49: { name: 'password', use: 'text', type: 'string' },
      50: { name: 'language_switch', use: 'language_switch', type: 'string' },
      51: { name: 'image_autocomplete', use: 'image_autocomplete' },
      300: { name: 'login', use: 'login' },
      301: { name: 'ideal', use: 'ideal' },
      302: { name: 'mortgage', use: 'mortgage' },
      303: { name: 'pieslider', use: 'pieslider' },
      100: { name: 'message', use: 'message', type: 'string' },
      102: { name: 'return', use: 'yesno' },
    }
    return questionTypes[type]
  },
  requestRedirect: function (url, target, follow) {
    this.populateValues(
      url,
      function (url) {
        if (follow) {
          this.connPut('redirect', { url: url, target: target || '_self', follow: follow })
        } else {
          this.exit(
            function () {
              this.connPut('redirect', { url: url, target: target || '_self' })
            }.bind(this)
          )
        }
      }.bind(this)
    )
    if (follow) {
      return this.exportQuestion(this.getQuestion(follow)[0])
    }
  },
  compileCondition: function (condition) {
    var items = []
    for (var i = 0; i < condition.rules.length; i++) {
      var rule = condition.rules[i]
      if (rule.combinator) {
        items.push(this.compileCondition(rule))
      } else {
        var question = this.getQuestion(rule.field).getLast()
        if (question) {
          var text = this.getAnswer(rule.field, 'content')
          var value = this.getAnswer(rule.field, 'value')
          var ruleValue = rule.value
          if (typeof value === 'undefined') {
            value = ''
          }
          if (typeof text === 'undefined') {
            text = ''
          }
          if (question.question_options) {
            if (typeOf(value).toLowerCase() !== 'array') {
              if (value) {
                value = [value]
              } else {
                value = []
              }
            }
            value = value
              .map(function (item) {
                var option = question.question_options.find(function (option) {
                  return (option.type && option.type == item) || option.id == item
                })
                if (option) {
                  return option.id
                }
              })
              .filter(Boolean)
          }
          var typeName = this.getQuestionType(question.question_type).type
          if (question.question_type === '8') {
            value = moment(value).utc()
            ruleValue = moment.utc(ruleValue)
            if (!question.meta || !question.meta.isDateTime) {
              ruleValue = ruleValue.startOf('day')
              value = value.startOf('day')
            }
            ruleValue = ruleValue.unix()
            value = value.unix()
          } else if (question.question_type === '11') {
            value = parseFloat(value)
            ruleValue = parseFloat(ruleValue)
          } else if (question.question_type === '19') {
            value = moment().diff(moment(value), 'years')
          } else if (rule.operator.indexOf('>') >= 0 || rule.operator.indexOf('<') >= 0) {
            value = parseFloat(value)
            ruleValue = parseFloat(ruleValue)
          }
          var operator = rule.operator === '=' ? '==' : rule.operator
          operator = operator === '!=' ? '!=' : operator
          if (typeName === 'string') {
            value = text
          }
          if (typeName === 'string' && operator === 'contains') {
            var parts = []
            if (Array.isArray(ruleValue)) {
              for (var k = 0; k < ruleValue.length; k++) {
                parts.push([JSON.encode(value), '.indexOf(', JSON.encode(ruleValue[k]), ') >= 0'].join(''))
              }
            } else {
              parts.push([JSON.encode(value), '.indexOf(', JSON.encode(ruleValue), ') >= 0'].join(''))
            }
            items.push(parts.join(' || '))
          } else if (typeName === 'string' && operator === 'notContains') {
            var parts = []
            if (Array.isArray(ruleValue)) {
              for (var k = 0; k < ruleValue.length; k++) {
                parts.push([JSON.encode(value), '.indexOf(', JSON.encode(ruleValue[k]), ') === -1'].join(''))
              }
            } else {
              parts.push([JSON.encode(value), '.indexOf(', JSON.encode(ruleValue), ') === -1'].join(''))
            }
            items.push(parts.join(' && '))
          } else if (typeName === 'string' && operator === 'icontains') {
            var parts = []
            if (Array.isArray(ruleValue)) {
              for (var k = 0; k < ruleValue.length; k++) {
                parts.push(
                  [
                    JSON.encode(value.toLowerCase()),
                    '.indexOf(',
                    JSON.encode(ruleValue[k].toLowerCase()),
                    ') >= 0',
                  ].join('')
                )
              }
            } else {
              parts.push(
                [JSON.encode(value.toLowerCase()), '.indexOf(', JSON.encode(ruleValue.toLowerCase()), ') >= 0'].join('')
              )
            }
            items.push(parts.join(' || '))
          } else if (typeName === 'string' && operator === 'notIcontains') {
            var parts = []
            if (Array.isArray(ruleValue)) {
              for (var k = 0; k < ruleValue.length; k++) {
                parts.push(
                  [
                    JSON.encode(value.toLowerCase()),
                    '.indexOf(',
                    JSON.encode(ruleValue[k].toLowerCase()),
                    ') === -1',
                  ].join('')
                )
              }
            } else {
              parts.push(
                [JSON.encode(value.toLowerCase()), '.indexOf(', JSON.encode(ruleValue.toLowerCase()), ') === -1'].join(
                  ''
                )
              )
            }
            items.push(parts.join(' && '))
          } else if (typeName === 'string' && operator === 'ieq') {
            items.push([JSON.encode(value.toLowerCase()), '==', JSON.encode(ruleValue.toLowerCase())].join(''))
          } else if (typeName === 'string' && operator === 'ineq') {
            items.push([JSON.encode(value.toLowerCase()), '!=', JSON.encode(ruleValue.toLowerCase())].join(''))
          } else if (operator === 'in') {
            if (!Array.isArray(value)) {
              value = [value]
            }
            items.push([JSON.encode(value), '.intersect(', JSON.encode(ruleValue), ').length'].join(''))
          } else if (operator === 'notIn') {
            if (!Array.isArray(value)) {
              value = [value]
            }
            items.push(['!', JSON.encode(value), '.intersect(', JSON.encode(ruleValue), ').length'].join(''))
          } else {
            items.push([JSON.encode(value), operator, JSON.encode(ruleValue)].join(''))
          }
        }
      }
    }
    var res = items
      .filter(function (item) {
        return item
      })
      .map(function (item) {
        return '(' + item + ')'
      })
      .join(condition.combinator.toLowerCase() === 'and' ? '&&' : '||')
    // console.log(res)
    return res
  },
  getConditionalNext: function (options, otherid, answer, question) {
    if (typeOf(answer).toLowerCase() === 'array') {
      answer = answer.getLast()
    }

    if (question.conditionalResponses) {
      for (var i = 0; i < question.conditionalResponses.length; i++) {
        var response = question.conditionalResponses[i]
        var condition = this.compileCondition(response.condition)
        if (eval(condition)) {
          if ((response.option && response.option == answer) || !response.option) {
            var nextKey = response.next
            if (this.exitNexts.indexOf(nextKey) > -1 || (typeof nextKey === 'object' && nextKey)) {
              return nextKey
            }
            return this.exportQuestion(this.getQuestion(nextKey)[0])
          }
        }
      }
    }
  },
  exitNexts: ['exit', 'restart', 'live_chat'],
  getQuestionNext: function (options, otherid, answer, question, callback) {
    if (this.gotoNext) {
      options = this.gotoNext
      this.gotoNext = null
    } else if (typeOf(options).toLowerCase() == 'object') {
      var nextQuestion = this.getConditionalNext(options, otherid, answer, question)
      if (nextQuestion) {
        if (typeof nextQuestion === 'object' && nextQuestion) {
          if (nextQuestion.url) {
            return callback(this.requestRedirect(nextQuestion.url, nextQuestion.urlTarget, nextQuestion.follow))
          }
          if (nextQuestion.saveChat) {
            var nextKey = nextQuestion.next
            return this.saveChat(
              function () {
                return callback(this.exportQuestion(this.getQuestion(nextKey)[0]))
              }.bind(this)
            )
          }
        }

        if (this.exitNexts.indexOf(nextQuestion) > -1) {
          return callback(nextQuestion)
        }

        return callback(nextQuestion)
      }
      if (typeOf(answer).toLowerCase() == 'array') {
        if (otherid && answer.indexOf(otherid.toString()) >= 0) {
          return callback(this.exportQuestion(this.getQuestion(options[otherid])[0]))
        }

        var selected = [],
          counted = 0,
          predominant = null

        predominant = answer.filter(function (item) {
          return options[item]
        })[0]

        var nextKey = typeof predominant !== 'undefined' ? options[predominant] : options['*']
        if (typeof nextKey === 'object' && nextKey) {
          if (nextKey.url) {
            return callback(this.requestRedirect(nextKey.url, nextKey.urlTarget, nextKey.follow))
          }
          if (nextKey.saveChat) {
            nextKey = nextKey.next
            var cb = callback
            callback = function (_new) {
              this.saveChat(function () {
                return cb(_new)
              })
            }.bind(this)
          }
        }

        if (this.exitNexts.indexOf(nextKey) > -1) {
          return callback(nextKey)
        }

        return callback(this.exportQuestion(this.getQuestion(nextKey)[0]))
      }
      var nextKey = options[answer] ? options[answer] : options['*']

      if (typeof nextKey === 'object' && nextKey) {
        if (nextKey.url) {
          return callback(this.requestRedirect(nextKey.url, nextKey.urlTarget, nextKey.follow))
        }
        if (nextKey.saveChat) {
          nextKey = nextKey.next
          var cb = callback
          callback = function (_new) {
            this.saveChat(function () {
              return cb(_new)
            })
          }.bind(this)
        }
      }
      if (this.exitNexts.indexOf(nextKey) > -1) {
        return callback(nextKey)
      }
      return callback(this.exportQuestion(this.getQuestion(nextKey)[0]))
    }

    if (typeOf(options).toLowerCase() == 'string' || typeOf(options).toLowerCase() == 'number') {
      if (this.exitNexts.indexOf(options) > -1) {
        return callback(options)
      }
      return callback(this.exportQuestion(this.getQuestion(options)[0]))
    }
  },
  hasLanguageSwitched: function () {
    return quriobot.store.get(this.getLangStorageKey())
  },
  exportQuestion: function (question, dataKey) {
    if (!question.start) {
      question.start = new Date().toISOString()
    }
    var exportObj = {
      key: question.key,
      type: 'question',
      code_name: question.code_name,
      contains: [],
      rendered: [],
      texts: [],
      start: question.start,
    }

    //textual items.
    if (!question.question_saved) {
      // if the question should be fully answered.
      if (question.question) {
        var obj = typeOf(question.question).toLowerCase() == 'array' ? question.question : [question.question]
        if (!(question.question_type == 50 && this.hasLanguageSwitched())) {
          // language is not switched
          obj.each(function (str, i) {
            exportObj.contains.push({
              type: 'bot',
              str: str,
              key: question.key,
            })
          })
        }
      }

      if (question.question_help) {
        var obj =
          typeOf(question.question_help).toLowerCase() == 'array' ? question.question_help : [question.question_help]
        obj.each(function (str, i) {
          exportObj.contains.push({
            type: 'bot',
            str: question.question_help,
            key: question.key,
          })
        })
      }
    } else {
      // if question allready has an answer, that was prefilled.
      // text defines the preset condition, so it doesn't look stupid
      if (question.question_saved.render && question.question_saved.text) {
        var obj =
          typeOf(question.question_saved.text).toLowerCase() == 'array'
            ? question.question_saved.text
            : [question.question_saved.text]
        obj.each(function (str, i) {
          exportObj.contains.push({
            type: 'bot',
            str: str,
            key: question.key,
          })
        })
      }
    }

    //question items.
    var q = {
      anchor: question.question_anchor || false,
      api: this.getBotOption('apiFetch', question.question_id) || false,
      choices: question.question_choices || false,
      id: question.question_id,
      index: question.question_index || null,
      key: question.key,
      code_name: question.code_name,
      meta: question.meta || {},
      privacy: this.getBotOption('privacy'),
      terms: this.getBotOption('terms'),
      is_required: question.is_required,
      randomize_options: question.randomize_options,
      next:
        question.question_next && question.question_next.default
          ? question.question_next.default
          : question.question_next || false,
      options: question.question_options || false,
      other: question.question_hasOther || false,
      placeholder: (question.meta && question.meta.placeholder) || '',
      responses: this.getResponses(question.key) || false,
      conditionalResponses: this.getConditionalResponses(question.key) || false,
      responsecondition: this.getResponseCondition(question.key) || false,
      total: question.question_total || null,
      type: this.getQuestionType(question.question_type),
      url: question.question_url || false,
      display_html: question.question_display_html || false,
      savedValue: question.question_saved || false,
      question: question.question,
      language: this.getBotOption('language'),
      minTime: question.meta && question.meta.minTime,
      maxTime: question.meta && question.meta.maxTime,
      stepSize: question.meta && question.meta.step_size,
      title: (question.meta && question.meta.title) || '',
      i18n: this.getBotOption('i18n'),
      accessibilityMode: this.accessibilityMode,
      start: question.start,
    }

    // Add default translation to the `goButton` if yesno_display step and
    // there is no go_button_text
    if (q.type.name === 'yesno_display' && !q.meta.go_button_text) {
      q.meta.go_button_text = 'Open'
    }

    exportObj.contains.push(q)

    if (dataKey) {
      var dataItems = typeOf(dataKey).toLowerCase() == 'array' ? dataKey : [dataKey]
      var exportResults = {}

      dataItems.each(function (key) {
        exportResults[key] = exportObj.contains.getLast()[key]
      })
      return exportResults
    }
    return exportObj
  },
})

var Answers = new Class({
  getTexts: function (stateItem) {
    var texts = []
    if (stateItem) {
      for (var i = 0; i < stateItem.rendered.length; i++) {
        var id = stateItem.rendered[i]
        var el = $(id)
        if (el && el.getElements) {
          var content =
            el.getElements('.bot--text')[0] ||
            (el.hasClass('bot--link') && el.getElements('.panel--main')[0]) ||
            el.getElements('.panel--content')[0] ||
            el.getElements('.bot-image')[0] ||
            el.getElements('.panel--main')[0]
          if (content) {
            texts.push(content.get('html').trim())
          }
        }
      }
    }
    return texts
  },
  exportAnswer: function (itemObj, answerObj, save, index) {
    if (!save) {
      var exportObj = {
        key: itemObj.key,
        id: itemObj.id,
        type: 'answer',
        meta: itemObj.meta || false,
        value: answerObj.answer.value,
        content: answerObj.answer.content,
        contains: [],
        rendered: [],
        texts: [],
        start: itemObj.start,
        stop: new Date().toISOString(),
      }

      if (answerObj.answer) {
        answerObj.answer.type = 'answer'
        answerObj.answer.key = itemObj.key
        answerObj.answer.i18n = this.getBotOption('i18n')
        exportObj.contains.push(answerObj.answer)
      }
    } else {
      var question = this.exportQuestion(this.getQuestion(answerObj.key)[0]).contains.getLast()
      var stateQuestion = this.getRenderedState('question', answerObj.key, true)[index || 0]
      var questionTexts = stateQuestion ? stateQuestion.texts : []
      var stateResponse = this.getRenderedState('response', answerObj.key, true)[index || 0]
      var responses = stateResponse ? stateResponse.texts : []
      question.question = questionTexts
      var exportObj = {
        question: question,
        text: {
          question_text: question.question_text,
          answers_text: answerObj.content,
        },
        value: {
          qId: question.question_id,
          type: question.question_type,
          value: answerObj.value,
        },
        start: question.start,
        stop: answerObj.stop,
        responses: responses,
      }
    }

    return exportObj
  },
  getAnswers: function () {
    return this.answers
  },
  getAnswer: function (answerKey, dataKey) {
    if (typeof answerKey !== 'number') {
      answerKey = parseInt(answerKey)
    }
    var answerObj = this.answers
      .filter(function (item) {
        return item.key === answerKey
      })
      .getLast()
    if (answerObj) {
      return dataKey ? answerObj[dataKey] : answerObj
    }
    return undefined
  },
})

var Responses = new Class({
  _Responses: [],
  setResponses: function (responses, isIntegrated) {
    if (isIntegrated === true) {
      Object.each(
        responses,
        function (obj, key) {
          if (obj.responses) {
            var respobj = { key: obj.key }
            Object.append(respobj, obj.responses)
            this._Responses.push(respobj)
          }
        }.bind(this)
      )
      return
    }

    Object.each(
      responses,
      function (obj, key) {
        obj['key'] = key
        this._Responses.push(obj)
      }.bind(this)
    )
  },
  getResponses: function (key) {
    if (!key || key == '*') {
      return this._Responses
    }

    var options = this._Responses.filter(function (item, i) {
      return item.key == key
    })
    return options.length ? Object.clone(options[0]).options : false
  },
  getConditionalResponses: function (key) {
    return (
      this._Responses.filter(function (item, i) {
        return item.key == key
      })[0] || {}
    ).conditions
  },
  getResponseCondition: function (key) {
    var options = this._Responses.filter(function (item, i) {
      return item.key == key
    })

    return options.length > 0 && options[0].conditional ? options[0].conditional : false
  },
  selectResponse: function (responseOptions) {
    if (responseOptions) {
      return responseOptions.getRandom()
    } else {
      return []
    }
  },
  getConditionalResponse: function (responses, otherid, answer, condition, question) {
    if (typeOf(answer).toLowerCase() === 'array') {
      answer = answer.getLast()
    }

    if (question.conditionalResponses) {
      for (var i = 0; i < question.conditionalResponses.length; i++) {
        var response = question.conditionalResponses[i]
        var condition = this.compileCondition(response.condition)
        if (eval(condition)) {
          if ((response.option && response.option == answer) || !response.option) {
            return response.texts
          }
        }
      }
    }
  },
  getResponse: function (responses, otherid, answer, condition, question) {
    var conditional = ''
    var response = false

    if (condition) {
      conditional = this.getAnswer(condition, 'value')
    }
    var conditionalResponse = this.getConditionalResponse(responses, otherid, answer, condition, question)
    if (conditionalResponse) {
      response = conditionalResponse
    }
    if (!response) {
      if (typeOf(answer).toLowerCase() == 'array') {
        if (otherid) {
          response = this.selectResponse(responses[otherid] ? responses[otherid] : responses['*'])
        } else {
          response = this.selectResponse(responses[answer.getLast()] ? responses[answer.getLast()] : responses['*'])
        }
      } else if (typeof answer !== 'undefined' && answer !== null) {
        var result = Object.filter(responses, function (val, key) {
          return new RegExp((conditional.toString() + answer.toString()).escapeRegExp(), 'g').test(key)
        })

        response = this.selectResponse(
          result[0]
            ? result
            : responses[conditional.toString() + answer.toString()]
            ? responses[conditional.toString() + answer.toString()]
            : responses[conditional.toString() + '*']
            ? responses[conditional.toString() + '*']
            : responses['*']
        )
      }
    }
    if (response) {
      return response
    }
  },
  executeResponseAction: function (request) {
    switch (request.action) {
      case 'change':
        this.connPut('change', request)
        return true
      case 'execute':
        this.populateValues(
          request.script,
          function (url) {
            var request = {
              script: url,
            }
            this.connPut('execute', request)
          }.bind(this)
        )
        return true
      default:
        return
    }
  },
  exportResponse: function (key, response) {
    var exportObj = {
      key: key,
      type: 'response',
      contains: [],
      rendered: [],
      texts: [],
    }

    ;(response || []).each(function (str, i) {
      exportObj.contains.push({
        type: 'bot',
        str: str,
        key: key,
      })
    })

    return exportObj
  },
})

var Errors = new Class({
  _Errors: {},
  setErrors: function (errors) {
    this._Errors = errors
  },
  getError: function (question, type, message, callback) {
    if (message) {
      return callback(message)
    }
    var i18n = this.getBotOption('i18n')
    var error = '',
      metaError = question.meta && question.meta.errors ? true : false,
      defaultMessage = {
        invalid: i18n.step.defaultResponse.invalid,
        missing: i18n.step.defaultResponse.missing,
        not_found: i18n.step.defaultResponse.notFound,
      }[type]
    if (!metaError && this._Errors) {
      var errors = this._Errors[question.type.name]
      error = errors ? errors.getRandom() : ''
    }

    if (!error) {
      if (type) {
        var items = metaError ? question.meta.errors[type] : null
        error = items ? Array.from(items).getRandom() : defaultMessage
      }
    }

    if (Array.isArray(error)) {
      async.mapSeries(
        error,
        function (value, cb) {
          if (typeof value === 'object' && value !== null) {
            if (value.display_as === 'image') {
              var str = value.str

              value = '<img class="error--content__img" src="' + value.src + '" />'
            } else {
              value = value.content || defaultMessage
            }
          }

          this.populateValues(value, function (newValue) {
            return cb(null, newValue)
          })
        }.bind(this),
        function (err, results) {
          if (!err) {
            callback(results)
          }
        }
      )
    } else {
      callback(error)
    }
  },
})

var Theme = new Class({
  setTheme: function (theme) {
    if (!theme) {
      return
    }

    if (theme.load) {
      new Element('link', {
        rel: 'stylesheet',
        type: 'text/css',
        href: '/static/quriobot/assets/themes/' + theme.load + '/style.css',
      }).inject($$('head')[0], 'bottom')
    }

    if (theme.show_settings === false) {
      $('settings').setStyle('display', 'none')
    }
    if (theme.show_close === false) {
      $$('.close').addClass('hidden').getParent().removeClass('has-close')
    }
    if (theme.show_scroll === false) {
      $$('.scroll-arrows__top, .scroll-arrows__bottom').addClass('hidden').getParent().removeClass('has-arrows')
    }
    if (theme.body) {
      theme.body_left = theme.body.replace('right', 'left')
    }
    if (theme.avatar_image) {
      if (!(theme.avatar_image.indexOf('http') === 0) && !(theme.avatar_image.indexOf('/') === 0)) {
        theme.avatar_image = '/static/quriobot/assets/img/avatar/' + theme.avatar_image
      }
    }
    var cssStyle = 'body {display: block;}\n'
    var cssClasses = [
      // Body {background}
      { use: '{%body%}', style: 'background', items: ['#qre'] },
      // Body left {background}
      { use: '{%body_left%}', style: 'background', items: ['#qre.position--left'] },
      // Avatar background {background-color}
      { use: '{%avatar_background%}!important', style: 'background-color', items: ['.bot--avatar'] },
      // Avatar position {background-position}
      { use: '{%avatar_position%}', style: 'background-position', items: ['.bot--avatar'] },
      // Avatar size {background-size}
      { use: '{%avatar_size%}', style: 'background-size', items: ['.bot--avatar'] },
      // Theme color {background-color}
      {
        use: '{%theme_color%}!important',
        style: 'background-color',
        items: [
          '#powered--label',
          '.answer--body',
          '.dot--a:before',
          '.dot--b:before',
          '.dot--c:before',
          '.icon--checkWrapper.dark .check:before',
          '.icon--checkWrapper.dark .check:after',
          '.panel--navBack',
          '.panel--navNext',
          '.date--navMonths .month.current--month span',
          '.date--navYears',
          '.calendar--week .calendar--dayWrapper.selected--date .calendar--day',
          '.date--listYears',
          '#settings.show #settings--button:before',
          '#fold-out__close:hover',
          '.panel--anchor .panel--main',
          '.panel--anchor .panel--main .redo--x:before',
          '.panel--anchor .panel--main .redo--x:after',
          '#quriobot--TCDone span',
          '.pm--button:before',
          '.pm--button:after',
          '#settings--panel #info:hover',
          '.panel--autocomplete .panel--main',
          '.rating--dot:not(.display--stars):hover .dot--content',
          '.rating--dot:not(.display--stars):active .dot--content',
          '.rate--options:hover .rating--dot:not(.display--stars) .dot--content',
          '.rating--dot.selected--option .dot--content',
          '.rating--dot.selected--option:hover .dot--content',
          'button.go--button',
          '.flatpickr-day.selected',
          '.flatpickr-day.startRange',
          '.flatpickr-day.endRange',
          '.flatpickr-day.selected.inRange',
          '.flatpickr-day.startRange.inRange',
          '.flatpickr-day.endRange.inRange',
          '.flatpickr-day.selected:focus',
          '.flatpickr-day.startRange:focus',
          '.flatpickr-day.endRange:focus',
          '.flatpickr-day.selected:hover',
          '.flatpickr-day.startRange:hover',
          '.flatpickr-day.endRange:hover',
          '.flatpickr-day.selected.prevMonthDay',
          '.flatpickr-day.startRange.prevMonthDay',
          '.flatpickr-day.endRange.prevMonthDay',
          '.flatpickr-day.selected.nextMonthDay',
          '.flatpickr-day.startRange.nextMonthDay',
          '.flatpickr-day.endRange.nextMonthDay',
          '.large--button',
          '.done--button',
          '.icon--checkWrapper.fromRight',
          '.icon--checkWrapper.fromBottom',
          '#quriobot--TCDone span',
          '.input--button:not(.disallowed)',
          '#mortgage_limit:before',
          '#pieslider_current_value_arrow:before',
          '.terms .terms--link',
          '.terms .terms--button',
          '.bot-image__control',
          '.tingle-btn--primary',
          '.tingle-btn .icon__cancel::after',
          '.tingle-btn .icon__cancel::before',
          '.scroll-arrows .icon__arrow::before',
          '.scroll-arrows .icon__arrow::after',
          '.flatpickr-day:not(.disabled):hover',
        ],
      },
      // Theme color {color}
      {
        use: '{%theme_color%}!important',
        style: 'color',
        items: [
          '.panel--options ul li:hover .option--text',
          '.panel--options ul li.selected--option .option--text',
          '.isAnswered .panel--options ul li.selected--option .option--text',
          '.image--option .selected--option .option--text',
          '.calendar--week.calendar--header .calendar--dayWrapper .calendar--day',
          '.calendar--week .day--today .calendar--day',
          '.calendar--week .calendar--dayWrapper:hover .calendar--day',
          '.calendar--week .calendar--dayWrapper.date--inrange .calendar--day',
          '.date--listYearsContent .option--year.current',
          '.date--plusWrapper .date--plusOption:hover',
          '.yesno--option .option--content:hover .option--text',
          '.yesno--option.selected--option .option--content .option--text',
          '#settings--panel input[type="checkbox"]:checked + label span.settings--label',
          '#settings--panel input[type="checkbox"] + label.position--label span.settings--label',
          '.bot--body a',
          '.answer--body .product--description h1',
          '.label-min-max .label-title',
          '.label-min-max .label-value',
          '#mortgage_percentage',
          '#pieslider_percentage',
          '.option--image:after',
          '.input--button.disallowed .button--countdown',
          '.pieslider--form label.amount-label',
          '.button-label',
          '.panel--legal__link',
          '.pieslider--form .inline--input input',
          '.panel--main .dz-preview .dz-remove',
          '.option--image-before',
        ],
      },
      // Support_color {stroke}
      { use: '{%active_color%}!important', style: 'stroke', items: ['svg circle.graph--pay'] },
      // Theme color {border-bottom}
      { use: '10px solid {%theme_color%}!important', style: 'border-bottom', items: ['.answer--body:before'] },
      // Theme color {border-bottom}
      {
        use: '4px solid {%theme_color%}!important',
        style: 'border-bottom',
        items: ['#settings.show #settings--button .settings--wheel .wheel--tooth:after'],
      },
      // Theme color {border-color}
      {
        use: '{%theme_color%}!important',
        style: 'border-color',
        items: [
          '.pm--button',
          '.panel--optionsInner.hasScroll .panel--arrow.active .arrow:before',
          '#restart #restart--button::before',
          '#restart #restart--button::after',
          '.calendar--week .day--today .calendar--day',
          '.yesno--option .option--content:hover',
          '#settings--panel input[type="checkbox"]:checked + label span.settings--input',
          '.product--wrapper .check--wrapper:before',
          '.product--wrapper .check--wrapper',
          '.input--button.disallowed',
          '.flatpickr-day.selected',
          '.flatpickr-day.startRange',
          '.flatpickr-day.endRange',
          '.flatpickr-day.selected.inRange',
          '.flatpickr-day.startRange.inRange',
          '.flatpickr-day.endRange.inRange',
          '.flatpickr-day.selected:focus',
          '.flatpickr-day.startRange:focus',
          '.flatpickr-day.endRange:focus',
          '.flatpickr-day.selected:hover',
          '.flatpickr-day.startRange:hover',
          '.flatpickr-day.endRange:hover',
          '.flatpickr-day.selected.prevMonthDay',
          '.flatpickr-day.startRange.prevMonthDay',
          '.flatpickr-day.endRange.prevMonthDay',
          '.flatpickr-day.selected.nextMonthDay',
          '.flatpickr-day.startRange.nextMonthDay',
          '.flatpickr-day.endRange.nextMonthDay',
          '.option--image:after',
          '#arrow--icon::before',
          '.login--form .inline--input input:focus',
          '.mortgage--form .inline--input input:focus',
          '.pieslider--form .inline--input input:focus',
          '.tingle-btn',
          '.flatpickr-day.today',
          '.flatpickr-day:not(.disabled):hover',
          '.panel--options__list_type_grid li.selected--option',
          '.panel--main .dz-clickable',
          '.option .option--text .option--comment',
          '.image--option .option--text .option--comment:hover',
        ],
      },
      // Theme color {border-left-color}
      { use: '{%theme_color%}!important', style: 'border-left-color', items: ['#restart #restart--button'] },
      // Theme color {border-right-color}
      { use: '{%theme_color%}!important', style: 'border-right-color', items: ['#restart #restart--button'] },
      // Active color {background-color}
      {
        use: '{%active_color%}!important',
        style: 'background-color',
        items: [
          '.large--button:hover',
          '.done--button:hover',
          '.input--button:hover',
          '#quriobot--TCDone span:hover',
          'button.go--button:hover',
          '.pm--button:hover:before',
          '.pm--button:hover:after',
          '.bot-image__control:hover',
          '.tingle-btn--primary:hover',
          '.tingle-btn:hover .icon__cancel::before',
          '.tingle-btn:hover .icon__cancel::after',
          '.scroll-arrows .icon__arrow:not(.is-disabled):hover',
        ],
      },
      // Active color {border-color}
      { use: '{%active_color%}!important', style: 'border-color', items: ['.pm--button:hover', '.tingle-btn:hover'] },
      // Redo color {background-color}
      {
        use: '{%redo_color%}!important',
        style: 'background-color',
        items: ['.icon--redoWrapper:not(.disabled):hover'],
      },
      // Image color {background-color}
      { use: '{%image_color%}!important', style: 'background-color', items: ['.option--image:before'] },
      // Attention color {background-color}
      {
        use: '{%attention_color%}!important',
        style: 'background-color',
        items: ['.prompt--content', '.bot--avatar.prompt', '.input--error .error--content'],
      },
      // Attention avatar color {background-color}
      {
        use: '{%attention_avatar%}!important',
        style: 'background-color',
        items: ['.input--error .error--avatar', '.bot--avatar.prompt'],
      },
      {
        use: '#d4d7d9 !important',
        style: 'background-color',
        items: ['.rating--dot:not(.display--stars):hover ~ .rating--dot .dot--content'],
      },
      {
        use: '7px solid #d4d7d9 !important',
        style: 'border-top',
        items: ['.rating--dot.display--stars:hover ~ .rating--dot.display--stars .star--element'],
      },
      // Theme color {border-top}
      {
        use: '7px solid {%theme_color%}!important',
        style: 'border-top',
        items: [
          '.rating--dot.display--stars:hover .star--element',
          '.rating--dot.display--stars.selected--option .star--element',
          '.rate--options:hover .rating--dot.display--stars .star--element',
        ],
      },

      // Text color {color}
      {
        use: '{%text_color%}!important',
        style: 'color',
        items: [
          '.bot--body',
          '.option--text',
          'body',
          '.flatpickr-day',
          '.flatpickr-months .flatpickr-month',
          'span.flatpickr-weekday',
          '.flatpickr-day.disabled',
          '.flatpickr-day.disabled:hover',
          '.input--content .data--wrapper',
        ],
      },

      // Text color for input placeholder {color}
      { use: '{%text_color%}', style: 'color', items: ['.input--content .data--wrapper::placeholder'] },
      { use: '{%text_color%}', style: 'color', items: ['.input--content .data--wrapper::-webkit-input-placeholder'] },
      { use: '{%text_color%}', style: 'color', items: ['.input--content .data--wrapper:-ms-input-placeholder'] },
      { use: '{%text_color%}', style: 'color', items: ['.input--content .data--wrapper::-ms-input-placeholder'] },
      { use: '{%text_color%}', style: 'color', items: ['.input--content .data--wrapper:-moz-input-placeholder'] },
      { use: '{%text_color%}', style: 'color', items: ['.input--content .data--wrapper::-moz-input-placeholder'] },

      // Text color {border-color}
      {
        use: '{%text_color%}',
        style: 'border-color',
        items: ['#settings--button .settings--wheel', '#settings--button .settings--wheel .wheel--tooth:after'],
      },

      // Fill color {fill}
      {
        use: '{%text_color%}!important',
        style: 'fill',
        items: ['.flatpickr-months .flatpickr-prev-month', '.flatpickr-months .flatpickr-next-month'],
      },

      // Inverse text color {color}
      {
        use: '{%inverse_text_color%}!important',
        style: 'color',
        items: ['.flatpickr-day:hover', '.go--button'],
      },

      // Inverse text color {color}
      {
        use: '{%inverse_text_color%}!important',
        style: 'color',
        items: [
          '.answer--body',
          '.large--button .button--text',
          '.icon--checkWrapper .check-outline span',
          '.icon--checkWrapper .check-outline::before',
          '.icon--checkWrapper .check-outline::after',
          '.panel--autocomplete .panel--main li',
        ],
      },

      // Inverse color {background-color}
      {
        use: '{%inverse_text_color%}!important',
        style: 'background-color',
        items: [
          '.icon--checkWrapper .check::before',
          '.icon--checkWrapper .check::after',
          '.panel--navBack span:before',
          '.panel--navNext span:before',
          '.goarrow--body',
          '.icon--checkWrapper .check:after',
          '.icon--checkWrapper .check:before',
          '.goarrow--body:before',
          '.goarrow--body:after',
        ],
      },

      // Inverse color {border-color}
      {
        use: '{%inverse_text_color%}!important',
        style: 'border-color',
        items: ['[dir] .input--button:before', '[dir] .panel--navNext span:after', '[dir] .panel--navBack span:after'],
      },

      // Message background {background-color}
      {
        use: '{%message_background%}!important',
        style: 'background-color',
        items: [
          '.bot--body',
          '.panel--main',
          '.image--optionBody',
          '.input--inner',
          '#toolbar--inner',
          '#settings--panel',
          '.terms--popup',
          '.scroll-arrows',
          '.tingle-modal-box',
          '.option .option--text .option--comment',
          '.image--option .option--text .option--comment:hover',
        ],
      },

      // Multiple choice bottom gradient {background}
      {
        use: 'linear-gradient(to top,{%message_background%} 80%, rgba(255,255,255,0))',
        style: 'background',
        items: ['[dir] .panel--optionsInner.hasScroll .panel--arrow'],
      },
      // Multiple choice top gradient {background}
      {
        use: 'linear-gradient(to bottom,{%message_background%} 80%, rgba(255,255,255,0))',
        style: 'background',
        items: ['[dir] .panel--optionsInner.hasScroll .panel--arrow.arrow--up'],
      },
    ]
    cssClasses.each(function (object, index) {
      var themeKey = object.use.match(/{%.*%}/g)
      themeKey = themeKey && themeKey[0].replace(/\{|\}|\%/g, '')
      if (theme[themeKey] || !themeKey) {
        var styleVar = object.use.replace(/{%.*%}/g, theme[themeKey])
        cssStyle += object.items.join(',') + '{' + object.style + ':' + styleVar + ';}'
      }
    })

    if (theme.css) {
      cssStyle += '\n' + theme.css
    }

    if (theme.avatar_image) {
      this.changeAvatar(theme.avatar_image)
    }
    if (this.getBotOption('disableRedo')) {
      cssStyle += '\n' + '.icon--redoWrapper {display: none;}'
    }
    new Element('style', { type: 'text/css', name: 'theme-css', html: cssStyle }).inject($$('head')[0], 'bottom')
  },
  changeAvatar: function (avatar) {
    var cssClasses = [
      {
        use: "url('" + avatar + "')",
        style: 'background-image',
        items: [
          '.bot--avatar',
          '.socialIcon.socialIcon-default',
          '.input--error .error--avatar',
          '.fold-out__avatar',
          '#powered--label:after',
        ],
      },
    ]
    var cssStyle = ''
    cssClasses.each(function (object, index) {
      var styleVar = object.use
      cssStyle += object.items.join(',') + '{' + object.style + ':' + styleVar + ';}'
    })
    var themeCss = $('theme-avatar-css')
    if (themeCss) {
      themeCss.set('html', cssStyle)
    } else {
      new Element('style', {
        type: 'text/css',
        id: 'theme-avatar-css',
        name: 'theme-avatar-css',
        html: cssStyle,
      }).inject($$('head')[0], 'bottom')
    }
  },
})

var Quriobot = new Class({
  _State: [],
  _FullState: [],
  Implements: [Answers, Connection, Errors, NaturalDelay, Questions, RandomId, Redo, Responses, Theme, View],
  userStatus: null,
  startTime: null,
  stopTime: null,
  directionRtl: function () {
    var language = this.getBotOption('language'),
      isRtl = this.getBotOption('isRtl')

    // Set dir="rtl" to html tag if language is rtl
    if (isRtl) {
      $$('html').setProperty('dir', 'rtl')
    }
  },
  accessibilityMode: false,
  screenReaderDetect: function () {
    var i18n = this.getBotOption('i18n')
    $('screenReaderDetect')
      .addEvents({
        click: function (e) {
          this.accessibilityMode = true
          var _state = this._State

          if (_state && _state.length) {
            var firstMessage = _state[0].rendered[0]

            $(firstMessage)
              .set({
                tabindex: -1,
                role: 'text',
              })
              .focus()
          }
        }.bind(this),
      })
      .set('text', i18n.accessibility.button)
  },
  isComplete: false,
  handleExit: function () {
    // var restoreState = this.getBotOption('restoreState')
    // console.log('handleExit', this.isComplete)
    // Call saveBot if bot isn't complete
    this.saveBot()
  },
  userAction: function (action, element, callback) {
    var startTime = !this.startTime ? new Date().toISOString() : this.startTime

    var key = null,
      id = null,
      questionItem = null,
      version = false,
      answers = [],
      answer = null

    if ($$('meta[name="version"]').length > 0) {
      version = $$('meta[name="version"]')[0].get('content')
    }

    switch (action) {
      case 'redo':
        this.userStatus = 'redo'
        break
      case 'leave':
        this.userStatus = 'leave'
        break
      case 'return':
        this.userStatus = this.userStatus == 'leave' ? null : this.userStatus
        break
      case 'answer':
        action = this.userStatus == 'redo' ? 'answerRedo' : action
        this.userStatus = this.userStatus == 'redo' ? null : this.userStatus
        break
      case 'start':
        questionItem = { id: 'start', key: 'start' }
        break
      default:
        this.userStatus = null
    }
    var _a = this.getAnswers()
    var answersByKey = {}
    _a.each(
      function (object) {
        var answerByKey = answersByKey[object.key]
        if (!answerByKey) {
          answerByKey = answersByKey[object.key] = []
        }
        answerByKey.push(object)
        object = this.exportAnswer(null, object, true, answerByKey.length - 1)
        answers.push(object)
      }.bind(this)
    )

    if (!questionItem) {
      var fullItem
      if (element) {
        fullItem = this.getQuestion(element.get('family').toInt())[0]
      } else {
        var lastStateItem = this._State.getLast()
        if (lastStateItem) {
          fullItem = this.getQuestion(lastStateItem.key)[0]
        }
      }
      if (fullItem) {
        questionItem = this.exportQuestion(fullItem).contains.getLast()
      }

      if (questionItem) {
        answer = answers
          .filter(
            function (object) {
              return questionItem && object.question.key == questionItem.key
            }.bind(this)
          )
          .getLast()
      }
    }

    var stopTime = action == 'finish' || action == 'liveChat' ? new Date().toISOString() : null

    this.startTime = startTime
    this.stopTime = stopTime
    this.isComplete = action == 'finish' || action == 'liveChat' ? true : false
    var isReturning = this.variables.find(function (item) {
      return item.name === 'infoIsReturning'
    })
    var visitCount = this.variables.find(function (item) {
      return item.name === 'infoVisitCount'
    })
    // console.log(visitCount, isReturning)
    var actionObj = {
      name: this.name,
      type: action,
      id: questionItem ? questionItem.id : null,
      key: questionItem ? questionItem.key : null,
      answers: answers || null,
      question: questionItem,
      answer: answer,
      info: {
        browser: BrowserData.Name,
        deviceBrand: BrowserData.Brand,
        deviceType: BrowserData.Device,
        platform: BrowserData.Platform,
        version: version ? version : 'unknown',
        environment: DATA ? DATA.env : 'unknown',
        referer: this.getBotOption('referer'),
        isReturning: isReturning ? { false: false, true: true }[isReturning.value] : false,
        visitCount: visitCount ? parseInt(visitCount.value) : 0,
      },
      isComplete: this.isComplete,
      recaptchaResponse: this.recaptchaResponse,
      responseId: this.responseId,
    }
    var actionHandler = actionObj.type.toString()
    actionHandler = 'on' + actionHandler.substr(0, 1).toUpperCase() + actionHandler.substr(1)
    var storedData = {
      answers: actionObj.answers,
      info: actionObj.info,
      name: actionObj.name,
      isComplete: actionObj.isComplete,
      start: startTime,
      stop: stopTime,
    }
    if (this[actionHandler]) {
      try {
        this[actionHandler](
          storedData,
          actionObj.question,
          actionObj.answer,
          actionObj,
          function () {
            this.connPut('user', actionObj, callback)
          }.bind(this)
        )
      } catch (error) {
        if (console) {
          console.warn(error)
        }
      }
    } else {
      this.connPut('user', actionObj, callback)
    }
  },
  onLoad: function (results) {},
  started: false,
  variables: [],
  onStart: function (results, question, answer, action, callback) {
    var startUrl = this.getBotOption('startUrl')
    var mode = this.getBotOption('mode')
    var referer = this.getBotOption('referer')
    var visitCount = this.variables.find(function (item) {
      return item.name === 'infoVisitCount'
    })
    if (startUrl && !this.started) {
      this.started = true
      this.checkCaptcha(
        function (response) {
          this.recaptchaResponse = response
          this.ajax(
            startUrl,
            function (responseText) {
              var resp = JSON.parse(responseText)
              this.responseId = resp.id
              action['responseId'] = resp.id
              action['variables'] = resp.variables
              this.variables = resp.variables
              callback()
            }.bind(this),
            {
              recaptchaResponse: this.recaptchaResponse,
              name: results.name,
              mode: mode,
              referer: referer,
              visitCount: visitCount ? visitCount.value : 0,
            },
            { 'Content-Type': 'application/json' }
          )
        }.bind(this)
      )
    }
  },
  ajax: function (url, callback, data, x) {
    try {
      var Cls = XMLHttpRequest || ActiveXObject
      x = new Cls('MSXML2.XMLHTTP.3.0')
      x.open(data ? 'POST' : 'GET', url, 1)
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
      x.setRequestHeader('Content-type', 'application/json')
      x.onreadystatechange = function () {
        if (x.readyState > 3 && callback) {
          callback(x.responseText, x)
        }
      }
      x.send(JSON.stringify(data))
    } catch (e) {
      if (window.console) {
        console.log(e)
      }
    }
  },
  onQuestion: function (results, question, answer, action, callback) {
    callback()
  },
  onAnswer: function (results, question, answer, action, callback) {
    this.saveBot()
    callback()
  },
  onClickRedo: function (data, element) {
    var i18n = this.getBotOption('i18n')
    var redoWarningText = this.getBotOption('redoWarningText') || i18n.redo.warning.text

    // initialize modal
    var redoModal = new tingle.modal({
      footer: true,
      stickyFooter: false,
      closeMethods: ['overlay', 'escape'],
      cssClass: ['tingle-modal_type_redo'],
      onOpen: function () {
        $$('.tingle-modal_type_redo')[0].set({
          role: 'alertdialog',
          'aria-modal': true,
          'aria-describedby': 'redoModalDescription',
        })

        $$('.tingle-btn--primary')[0].focus()
      },
      beforeClose: function () {
        $$('.tingle-modal_type_redo').removeClass('tingle-modal--visible')

        setTimeout(function () {
          return true
        }, 300)
      },
    })

    redoModal.setContent('<div id="redoModalDescription" class="tingle-modal-box__body">' + redoWarningText + '</div>')

    redoModal.addFooterBtn(
      '<div class="icon__check"></div>',
      'tingle-btn tingle-btn--primary',
      function () {
        if (this.currentStepElement) {
          this.currentStepElement.foldOutClose()
        }
        redoModal.close()
        redoModal.destroy()
        this.redo(data, element)
      }.bind(this)
    )

    redoModal.addFooterBtn('<div class="icon__cancel"></div>', 'tingle-btn', function () {
      redoModal.close()
      redoModal.destroy()
    })

    redoModal.open()
  },
  onAnswerRedo: function (results, question, answer, action, callback) {
    callback()
  },
  onFinish: function (results, question, answer, action, callback) {
    callback()
  },
  onLeave: function (results, question, answer, action, callback) {
    callback()
  },
  onRedo: function (results, question, answer, action, callback) {
    callback()
  },
  onReturn: function (results, question, answer, action, callback) {
    callback()
  },
  onExit: function () {},
  onLiveChat: function (results, question, answer, action, callback) {
    callback()
  },
  updateState: function (action, obj, returnVal) {
    if (!obj) {
      return
    }
    if (!action) {
      return
    }
    switch (action) {
      case 'add':
        this._State.push(obj)
        this._FullState.push(obj)
        if (returnVal) {
          return this._State
        } else {
          setTimeout(
            function () {
              this.playBot()
            }.bind(this),
            0
          )
        }
        break
      case 'remove':
      case 'update':
        var index = this.getRenderedIndex(obj.type, obj.key)[1]
        if (action == 'update') {
          var curElement = this._State[index]

          // Delete `rendered` array from item Object
          delete obj.rendered

          Object.each(obj, function (val, key) {
            if (typeof val === 'object') {
              // Deeply merge current element (answer) with the new object values
              curElement[key] = Object.merge(curElement[key], val)
            } else {
              // Replace old value with new one if typeof `value` isn't an `object`
              curElement[key] = val
            }
          })
          return
        }

        if (action == 'remove') {
          this._State.splice(index, 1)
          return
        }
        break
    }
  },
  getRenderedIndex: function (type, key) {
    var index = 0
    var item = {}

    this._State.each(function (obj, i) {
      if (obj.type == type && obj.key == key) {
        index = i
        item = obj
      }
    })

    return [item, index]
  },
  getRenderedState: function (type, key, isFull) {
    var _s = this._State
    if (isFull && this._FullState && this._FullState.length) {
      _s = this._FullState
    }

    return _s.filter(function (obj, i) {
      return obj.type == type && obj.key == key
    })
  },
  visibleElementsLimit: 50,
  setRenderedState: function (item, renderId) {
    if (this.isPurging) {
      return
    }

    var isnew = false
    var family = []
    var rendered = []

    this._State.each(function (stateItem) {
      rendered.append(stateItem.rendered)
      if (stateItem.key == item.key) {
        if (stateItem.rendered.length < stateItem.contains.length) {
          isnew = true
          family.push(stateItem)
        }

        if (stateItem.rendered.length >= stateItem.contains.length) {
          isnew = false
          family.push(stateItem)
        }
      }
    })

    var last = family.getLast()

    if (last) {
      var lastRendered = last.rendered
      var itemId = item.eid

      if (isnew) {
        lastRendered.push(itemId)
      } else {
        var renderedItemId = lastRendered[lastRendered.length - 1]

        if (!renderedItemId || renderedItemId === itemId) {
          renderedItemId = itemId
        }
      }
    }
    while (rendered.length > this.visibleElementsLimit) {
      var renderedItem = rendered.shift()
      var el = $(renderedItem)
      if (el) {
        el.set('morph', {
          transition: Fx.Transitions.Elastic.easeOut,
          duration: 500,
        })
        el.morph({ height: 0, opacity: 0 })
        ;(function () {
          if (el) {
            el.destroy()
          }
        }.delay(500))
      }
    }
  },
  answers: [],
  purgeBot: function (replay) {
    this.isPurging = true
    this.startedValidation = false
    this.validating = false
    this.started = false
    this.validateResponses = {}
    this.answers = []
    this._FullState = this._State = []
    this._Questions.map(function (item) {
      item.question_saved = false
      if (item.meta && Object.prototype.hasOwnProperty.call(item.meta, '_default')) {
        item.meta.default = null
      }
    })

    function purgeIt(container) {
      container
        .getElements('div')
        .filter(function (element) {
          if (container.get('id') === 'input--container') {
            return element.getParent().get('id') == 'input--container'
          }
          return !element.hasClass('persistent') && element.getParent().get('id') == 'conversation'
        })
        .each(function (element) {
          element.setStyles({
            opacity: 0,
          })
          // setTimeout(function(){
          element.dispose()
          // },800);
        })
    }
    purgeIt(this.app)
    purgeIt(this.inputContainer)
    if (replay) {
      setTimeout(
        function () {
          this.isPurging = false
          this.purgeView()
          this.startBot()
        }.bind(this),
        1500
      )
    } else {
      this.isPurging = false
      this.purgeView()
    }
  },
  checkCaptcha: function (callback) {
    var recaptchaSiteKey = this.getBotOption('recaptchaSiteKey')
    if (recaptchaSiteKey) {
      var recaptcha = $('recaptcha')
      if (recaptcha) {
        if (recaptcha.getChildren().length) {
          try {
            grecaptcha.reset()
          } catch (e) {}
        } else {
          grecaptcha.render('recaptcha', {
            sitekey: recaptchaSiteKey,
            size: 'invisible',
            badge: this.position === 'right' ? 'bottomright' : 'bottomleft',
            'expired-callback': function () {
              grecaptcha.reset()
            },
            callback: function (response) {
              callback(response)
            }.bind(this),
          })
        }
        grecaptcha.execute()
      }
    } else {
      callback()
    }
  },
  startBot: function (restore, restoreData) {
    if (!restore || !this.restoreBot(restoreData)) {
      setTimeout(
        function () {
          this.playBot()
        }.bind(this),
        0
      )
    }
    this.preview()
    this.attachLiveChat()
  },
  attachLiveChat: function () {
    var liveChat = this.getBotOption('liveChat')
    var i18n = this.getBotOption('i18n')

    if (liveChat) {
      var preview = $('liveChatButton')
      var buttonText = liveChat.button && liveChat.button.text
      var buttonTooltip = liveChat.button && liveChat.button.tooltip
      var button = $$('#liveChatButton .notification__title')
      button.set('text', buttonText)
      if (buttonText) {
        button.set('title', buttonTooltip)
      }

      var buttonEvents = {
        click: function () {
          button.removeEvents(buttonEvents)
          this.liveChat()
          $('liveChatButtonClose').click()
        }.bind(this),
      }
      button.addEvents(buttonEvents)

      preview.addClass('visible').setStyles({
        visibility: 'visible',
        display: 'flex',
        opacity: '1',
        transform: 'translate3d(0,0,0)',
        zIndex: 100,
      })
      var closeEvents = {
        click: function () {
          $('liveChatButtonClose').removeEvents(closeEvents)
          preview.removeClass('visible', true).setStyles({
            visibility: 'hidden',
            opacity: '0',
            transform: 'translate3d(100%,0,0)',
            zIndex: 100,
          })
        },
      }
      $('liveChatButtonClose').addEvents(closeEvents)
    }
  },
  preview: function () {
    var mode = this.getBotOption('mode'),
      i18n = this.getBotOption('i18n')

    if (mode === 'preview') {
      var preview = $('previewMode')

      $$('#previewMode .notification__title').set('text', i18n.notification.preview.title)

      preview.addClass('visible').setStyles({
        visibility: 'visible',
        display: 'flex',
        opacity: '1',
        transform: 'translate3d(0,0,0)',
        zIndex: 100,
      })
      var events = {
        click: function () {
          $('previewModeClose').removeEvents(events)
          preview.removeClass('visible', true).setStyles({
            visibility: 'hidden',
            opacity: '0',
            transform: 'translate3d(100%,0,0)',
            zIndex: 100,
          })
        },
      }
      $('previewModeClose').addEvents(events)
    }
  },
  setLocale: function (lang, languages, documentLanguage, useDynamicTranslation) {
    // Set locale for numeral
    var locales = numeral.locales, // numeral locales
      locale

    // Check if numeral locales has current bot locale
    if (locales && locales[lang]) {
      locale = lang
    } else {
      var splittedLang = lang.split('-')[0]
      if (locales && locales[splittedLang]) {
        locale = splittedLang
      }
    }
    if (locale) {
      numeral.locale(locale)
    }
    if (languages && documentLanguage && useDynamicTranslation) {
      this.initTranslation(lang, languages, documentLanguage)
    }
  },
  initTranslation: function (currentLanguage, languages, documentLanguage) {
    var supportedLanguage = languages.filter(function (lang) {
      return lang.split('-')[0] === documentLanguage
    })
    currentLanguage = currentLanguage.split('-')[0]
    if (!supportedLanguage.length && !this.hasLanguageSwitched()) {
      currentLanguage = documentLanguage
    }
    var QBa
    QBa = document.createElement('script')
    QBa.type = 'text/javascript'
    QBa.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
    window.Cookies.set('googtrans', '/auto/' + currentLanguage)
    window.Cookies.set('googtrans', '/auto/' + currentLanguage, { domain: '.quriobot.com' })
    window.Cookies.set('googtrans', '/auto/' + currentLanguage, { domain: '.botsrv.com' })
    window.googleTranslateElementInit = function () {
      new google.translate.TranslateElement(
        {
          pageLanguage: 'auto',
          // includedLanguages: languages,
          layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
          showBanner: true,
          autoDisplay: true,
          multilanguagePage: false,
        },
        'footer--toolbar'
      )
    }
    document.head.appendChild(QBa)
  },
  initDependencies: function (botData, callback) {
    var sources = []
    var mapsSteps = botData.questions.filter(
      function (item) {
        return this.getQuestionType(item.question_type).name === 'location'
      }.bind(this)
    )
    if (mapsSteps.length) {
      sources.push(
        'https://maps.googleapis.com/maps/api/js?v=3&libraries=places&key=AIzaSyAJPzKdO7XtCgc779z0hD_Y5eRFaDxg9oQ'
      )
    }
    if (this.getBotOption('recaptchaSiteKey')) {
      window.recaptchaOnloadCallback = callback
      sources.push('https://www.google.com/recaptcha/api.js?onload=recaptchaOnloadCallback&render=explicit')
    }
    async.map(
      sources,
      function (item, cb) {
        var QBa
        QBa = document.createElement('script')
        QBa.type = 'text/javascript'
        QBa.src = item
        QBa.onload = function () {
          cb(null, item)
        }
        document.head.appendChild(QBa)
      }.bind(this),
      function (err, results) {
        if (!err && !window.recaptchaOnloadCallback) {
          callback(results)
        }
      }
    )
  },
  loadBot: function (botOptions) {
    // console.log('frame - loadBot', botOptions)
    var onSuccess = function (botData) {
      if (!botData || !botData.questions) {
        console.log('error loading quriobot', botData)
        return
      }
      this.init()
      this.directionRtl()
      this.screenReaderDetect()
      botData.name = this.name = botOptions.use
      this.setLocale(
        botOptions.language,
        botData.languages &&
          botData.languages.map(function (item) {
            return item.code
          }),
        botOptions.documentLanguage,
        botData.useDynamicTranslation
      )
      this.setQuestions(botData.questions)
      this.variables = botData.variables || []
      this.terms()
      this.whiteLabel()

      if (botData.responses) {
        this.setResponses(botData.responses, false)
      } else {
        this.setResponses(botData.questions, true)
      }

      // Change widget direction to the left
      if (botOptions.position === 'left') {
        $('qre').addClass('position--left')
      }
      if (botOptions.position === 'center') {
        $('qre').addClass('position--center')
      }
      if (botOptions.position === 'full_width') {
        $('qre').addClass('position--full_width')
      }
      $('botPosition').set('value', botOptions.position)

      var unloaded = false
      window.addEventListener(
        'beforeunload',
        function (event) {
          if (unloaded) return
          unloaded = true
          this.handleExit(event)
        }.bind(this)
      )
      window.addEventListener(
        'pagehide',
        function (event) {
          if (unloaded) return
          unloaded = true
          this.handleExit(event)
        }.bind(this)
      )

      this.position = botOptions.position
      this.setErrors(botData.errors)
      if (botData.theme && botOptions.stickyAvatarPopup && botOptions.stickyAvatarPopup.image) {
        botData.theme.avatar_image = botOptions.stickyAvatarPopup.image
      }
      this.setTheme(botData.theme)
      if (botData.behavior && botData.behavior.messageDelay) {
        this.setNaturalDelayConfig(botData.behavior.messageDelay)
      }
      this.initDependencies(
        botData,
        function () {
          try {
            this.onLoad(botData)
          } catch (e) {
            console.log(e)
          }
          this.connPut('botHasData', botData)
        }.bind(this)
      )
    }.bind(this)
    if (!botOptions.botData) {
      new Request.JSON({
        method: 'get',
        url: botOptions.url + botOptions.use + '.json?lang=' + botOptions.language,
        async: true,
        onSuccess: onSuccess,
        onError: function (err) {
          console.log(err)
        }.bind(this),
      }).send()
    } else {
      onSuccess(botOptions.botData)
    }
  },
  saveBot: function () {
    if (!this.isComplete && this._State.length) {
      var data = {
        use: this.use,
        responseId: this.responseId,
        answers: this.answers,
        state: this._State,
        fullState: this._FullState,
        html: this.app.get('html'),
        followRedirect: false,
        isOpen: false,
        variables: this.variables,
      }
      this.connPut('saveBot', data)
      //   try {
      //     this.store.set(key, data, expiry)
      //   } catch (e) {
      //     console.log(e)
      //   }
    }
  },
  terms: function () {
    var terms = this.getBotOption('terms'),
      privacy = this.getBotOption('privacy'),
      i18n = this.getBotOption('i18n')

    if (!terms || !terms.linkURL || !privacy || !privacy.linkURL) {
      if ($('terms')) {
        $('terms').destroy() // remove terms for the old bots if there are no terms or privacy
      }
      $('toolbar--inner').addClass('no-terms')
    } else {
      $$('.terms--button').set('title', i18n.footer.terms.title)
      $('termsConditions')
        .setProperties({
          href: terms.linkURL,
          title: terms.text && new Element('div').appendHTML(terms.text).get('text'),
        })
        .set('text', terms.linkText)

      $('privacyPolicy')
        .setProperties({
          href: privacy.linkURL,
          title: privacy.text && new Element('div').appendHTML(privacy.text).get('text'),
        })
        .set('text', privacy.linkText)
    }
  },
  whiteLabel: function () {
    var whiteLabel = this.getBotOption('whiteLabel')

    if (whiteLabel === true) {
      $('powered--label').setStyle('display', 'none')
    } else {
      $('toolbar--inner').addClass('with-poweredLabel')
    }
  },
  validating: false,
  startedValidation: false,
  requestValidate: function (callback) {
    this.startedValidation = true
    if (!this.validating) {
      this.validateCallback = callback
      this.validating = true
      this.userAction('validate', null, false)
    }
  },
  validateResponses: {},
  validate: function (valid, errors, responses) {
    this.validating = false
    this.validateResponses = responses
    if (!valid) {
      var keys = Object.keys(errors)
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i]
        var error = errors[key]
        var question = this.getQuestion(key)[0]
        if (!valid && question.question_saved) {
          if (!question.meta) {
            question.meta = {}
          }
          if (typeof question.meta._default === 'undefined') {
            question.meta._default = question.meta.default
          }
          question.meta.default = question.question_saved.value
          question.question_saved = false
        }
        var _item = this.exportQuestion(question)
        _item.contains = !valid ? _item.contains.slice(-1) : []
        if (!Array.isArray(error)) {
          error = [error]
        }
        error.each(function (str, i) {
          _item.contains.splice(i, 0, {
            type: 'bot',
            str: str,
            key: key,
          })
        })
        _item.rendered = []
        this.updateState('add', _item)
        return
      }
    } else {
      this.startedValidation = false
      this.validateCallback()
    }
  },
  getRestoreQuestion: function () {
    var q = this._Questions.filter(
      function (question, i) {
        return question.question_type == '102'
      }.bind(this)
    )
    return q[0]
  },
  getLangStorageKey: function () {
    var res = 'qbLang-' + this.name
    var visitor = this.getBotOption('visitor')
    if (visitor) {
      res = res + '-' + visitor.id
    }
    return res
  },
  doRestoreBot: function () {
    var data = this.restoreBotData
    if (typeof data === 'object') {
      this.responseId = data.responseId
      this._State = data.state
      this._FullState = data.fullState || this._State
      this.answers = data.answers || []
      this.app.set('html', data.html)
      this.variables = data.variables
      var lastItem = this._State.getLast()
      var lastItemAnswer = this.getAnswer(lastItem.key, 'value')
      var lastItems = []
      if (typeof lastItemAnswer === 'undefined' || lastItemAnswer == null) {
        lastItems = this._State.filter(function (item) {
          return item.key == lastItem.key
        })
      }
      lastItems.each(function (item) {
        item.rendered.each(function (id) {
          id = $(id)
          if (id) {
            id.destroy()
          }
        })
      })

      if (lastItems.length) {
        this._State = this._State.slice(0, -lastItems.length)
      }
      var renderedIds = []
      this._State.each(
        function (_item) {
          _item.rendered.each(
            function (_id, index) {
              renderedIds.push(_id)
            }.bind(this)
          )
        }.bind(this)
      )
      if (lastItems.length) {
        this.app.getChildren().each(function (el) {
          if (
            (renderedIds.indexOf(el.get('id')) === -1 && el.get('class') && el.get('class').indexOf('bot--') === 0) ||
            el.get('family') == lastItem.key
          ) {
            el.destroy()
          }
        })
      }
      var renderedIndex = 0
      this._State.each(
        function (_item) {
          var answer = this.getAnswer(_item.key, 'value')
          _item.rendered.each(
            function (_id, index) {
              if (
                (typeof _item.contains[index].render === 'undefined' || _item.contains[index].render !== false) &&
                _item.contains[index].type.type !== 'string'
              ) {
                var toRender = _item.contains[index]
                toRender.answerValue = answer
                var hiddenLength = renderedIds.length - this.visibleElementsLimit
                if (hiddenLength <= 0 || renderedIndex >= hiddenLength) {
                  this.render(toRender, _id, false, true)
                }
                renderedIndex = renderedIndex + 1
              }
            }.bind(this)
          )
        }.bind(this)
      )
      this.clearSavedBot()
      return true
    }
    return false
  },
  restoreBotData: null,
  restoreBot: function (data) {
    if (typeof data === 'object') {
      this.restoreBotData = data
      var restoreQuestion = this.getRestoreQuestion()
      if (!data.followRedirect && restoreQuestion) {
        var _item = this.exportQuestion(restoreQuestion)
        this.updateState('add', _item)
        return true
      } else {
        this.doRestoreBot()
        setTimeout(
          function () {
            this.playBot()
          }.bind(this),
          0
        )
        return true
      }
    }
    return false
  },
  clearSavedBot: function () {
    this.connPut('clearSavedBot')
  },
  getValidateResponse: function (key) {
    var res = this.validateResponses[key]
    this.validateResponses = {}
    return res
  },
  getEntryPointStep: function () {
    var entryPoint = this.getBotOption('entryPoint')
    return this.exportQuestion(
      this.getQuestion(
        this._Questions.filter(function (item) {
          return item.question_type != '102' && (!entryPoint || (entryPoint && item.key === entryPoint))
        })[0].key
      )[0]
    )
  },
  playBot: function () {
    if (this.userStatus == 'leave') {
      this.userAction('return', null, false)
    }

    var _new,
      _id = this.newRandomId(),
      _item = this._State.getLast() || false

    if (!_item) {
      _item = this.getEntryPointStep()
      if (!this.started) {
        this.userAction('start')
      }
      this.updateState('add', _item)
      return
    }
    var contains = _item.contains,
      containsLength = contains.length,
      renderedLength = _item.rendered.length

    // evaluate state.
    // if there are more items, just continue
    if (containsLength > renderedLength) {
      this.render(contains[renderedLength], _id)
      return
    }

    // if this was the last item, evaluate answer and select appropriate.
    if (containsLength <= renderedLength) {
      var question = this.exportQuestion(this.getQuestion(_item.key)[0], [
          'responses',
          'responsecondition',
          'other',
          'next',
          'savedValue',
          'next_url',
          'conditionalResponses',
        ]),
        answer = this.getAnswer(_item.key, 'value')
      if (question && typeof answer !== 'undefined') {
        question.otherid = this.getQuestionOther(
          this.exportQuestion(this.getQuestion(_item.key)[0], ['options', 'other'])
        )
        if (
          _item.type == 'response' ||
          (_item.type == 'answer' && !$('botresponds').checked) ||
          (_item.type == 'answer' && typeOf(question.responses).toLowerCase() != 'object')
        ) {
          this.getQuestionNext(
            question.next,
            question.otherid,
            answer,
            question,
            function (_new) {
              if (_new) {
                if (_new === 'exit') {
                  return this.exit()
                } else if (_new === 'restart') {
                  return this.again()
                } else if (_new === 'live_chat') {
                  return this.liveChat()
                }

                if (typeof _new === 'object') {
                  var existingAnswer = this.getRenderedState('answer', _new.key).getLast()

                  // Call redo function if we go back to already answered question
                  if (existingAnswer) {
                    existingAnswer = existingAnswer.contains.getLast()
                    // Check if answer is rendered
                    // For example: `yesno` or `multiple choice` answer doesn't render
                    // If answer didn't render, so get this answer's question
                    // and call redo to that question
                    if (existingAnswer.render === false) {
                      var notRenderedAnswerQuestion = this.getRenderedState('question', existingAnswer.key).getLast()

                      if (notRenderedAnswerQuestion) {
                        notRenderedAnswerQuestion = notRenderedAnswerQuestion.contains.getLast()

                        this.redo(notRenderedAnswerQuestion, $(notRenderedAnswerQuestion.eid), true, true)
                        return
                      }
                    } else {
                      // Call redo if answer rendered
                      this.redo(existingAnswer, $(existingAnswer.eid), true, true)
                      return
                    }
                  }
                }

                this.updateState('add', _new)
              }
            }.bind(this)
          )
          return
        } else {
          if (question.savedValue) {
            var validateResponse = this.getValidateResponse(_item.key)
            _new = this.exportResponse(_item.key, validateResponse || [])
          } else {
            _new = this.exportResponse(
              _item.key,
              this.getResponse(question.responses, question.otherid, answer, question.responsecondition, question)
            )
          }
          this.updateState('add', _new)
          return
        }
      }
      return
    }
  },
  gotoNext: null,
  goto: function (key) {
    this.gotoNext = key
    if (this.currentStepElement) {
      this.currentStepElement.out()
    }
    this.getQuestionNext(
      key,
      null,
      null,
      null,
      function (_new) {
        if (_new) {
          this.updateState('add', _new)
        }
      }.bind(this)
    )
  },
  exit: function (callback) {
    setTimeout(
      function () {
        this.clearSavedBot()
        this.userAction('answer', null, false)
        this.requestValidate(function () {
          this.userAction(
            'finish',
            null,
            function () {
              this.connPut('done')
              if (typeof callback === 'function') {
                callback()
              }
            }.bind(this)
          )
        })
      }.bind(this),
      this.getNaturalDelay()
    )
  },
  getLiveChatUrl: function () {
    return this.getBotOption('liveChatUrl') + '/' + this.name + '/' + this.responseId
  },
  liveChat: function (callback) {
    setTimeout(
      function () {
        this.clearSavedBot()
        this.userAction('answer', null, false)
        this.requestValidate(function () {
          this.userAction(
            'liveChat',
            null,
            function () {
              var liveChat = this.getBotOption('liveChat')
              if (liveChat.type === 'native') {
                $('qre').addClass('hidden')
                this.connPut('liveChat')
                var liveChatFrame = $('liveChatFrame')
                var liveChatUrl = this.getLiveChatUrl()
                liveChatFrame.set('src', liveChatUrl)
                var liveChat = $('liveChat')
                var liveChatClose = $('liveChatClose')
                liveChatClose.addEvent(
                  'click',
                  function () {
                    liveChatFrame.contentWindow.postMessage({ qb: { action: 'close' } }, liveChatUrl)
                    liveChat.removeClass('visible')
                    $('qre').removeClass('hidden')
                    this.connPut('done')
                  }.bind(this)
                )
                liveChat.addClass('visible')
              } else if (liveChat.type === 'custom') {
                this.populateValues(
                  liveChat.script,
                  function (url) {
                    var request = {
                      script: url,
                    }
                    this.connPut('execute', request)
                    this.connPut('done')
                  }.bind(this)
                )
              } else {
                this.connPut('done')
              }
            }.bind(this)
          )
        })
      }.bind(this),
      this.getNaturalDelay()
    )
  },
  saveChat: function (callback) {
    if (this.redoActive) {
      if (typeof callback === 'function') {
        return callback()
      }
    }
    this.userAction('answer', null, false)
    this.requestValidate(function () {
      this.userAction(
        'finish',
        null,
        function () {
          this.started = false
          this.userAction('start')
          if (typeof callback === 'function') {
            callback()
          }
        }.bind(this)
      )
    })
  },
  changePosition: function (pos) {
    $('botPosition').setProperty('checked', pos !== 'left')
    pos === 'left' ? $('qre').addClass('position--left') : $('qre').removeClass('position--left')
  },
  modal: function (isOpened) {
    if (isOpened) {
      $('qre').addClass('modal--opened')
    } else {
      $('qre').removeClass('modal--opened')
    }
  },
  error: function (item, type, typeError, message) {
    this.getError(item, typeError, message, function (error) {
      $(item.eid).fireEvent('showError', { str: error })
    })
  },
  again: function () {
    this.userAction('answer', null, false)
    this.requestValidate(function () {
      this.userAction('finish', null, false)

      this.botOptions.savedAnswers = []
      var answerStorage = this.getBotOption('answerStorage')

      if (answerStorage) {
        answerStorage
          .filter(function (item, index) {
            return item.keep == true
          })
          .each(
            function (item) {
              var itemAnswer = this.getAnswer(item.key, 'content')
              if (typeof itemAnswer !== 'undefined') {
                var itemSaveData = {
                  key: item.key,
                  value: itemAnswer,
                  text: item.text || false,
                  render: item.render,
                }
                this.botOptions.savedAnswers.push(itemSaveData)
              }
            }.bind(this)
          )
      }
      this.purgeBot(true)
    })
  },
  answer: function (item, data, preset) {
    if (data && data.answer) {
      data.answer.stop = new Date().toISOString()
      this.answers.push(data.answer)
    }
    var _id = this.newRandomId(),
      _item = this.exportAnswer(item, data)

    if (_item) {
      if (this.getRenderedState(_item.type, _item.key).length) {
        this.updateState('update', _item)
        _item = this.getRenderedState(_item.type, _item.key)[0]
      } else {
        this.updateState('add', _item, true)
      }
      if (data.answer.render) {
        if (_item.contains.length > _item.rendered.length) {
          this.render(_item.contains[_item.rendered.length], _id)
          this.userAction('answer', null, false)
        } else if (_item.contains.length <= _item.rendered.length) {
          this.update(_item.contains.getLast(), _item.rendered.getLast())
          this.userAction('answer', null, true)
        }
      } else {
        var renderItem = _item.contains[_item.rendered.length] || _item.contains[0]
        this.render(renderItem, _id, true, false, preset)
        this.userAction('answer', null, false)
      }
    }
    if (item.type.name == 'return') {
      this._State.each(function (item) {
        item.rendered.each(function (id) {
          id = $(id)
          if (id) {
            id.destroy()
          }
        })
      })
      this._State = []
      if (data.answer.value == 'yes') {
        this.doRestoreBot()
      } else {
        this.clearSavedBot()
      }
    }
  },
  api: function (data, apiCallback) {
    this.connPut('api', data, apiCallback)
  },
  currentStepElement: null,
  createElement: function (item, id, useRenderer) {
    var useArguments = {
      default: [
        item,
        id,
        this.render.bind(this),
        this.answer.bind(this),
        this.error.bind(this),
        this.view.bind(this),
        this.onClickRedo.bind(this),
        this.again.bind(this),
        this.api.bind(this),
        this.populateValues.bind(this),
        this.getStepOptions.bind(this),
        this.validateAnswer.bind(this),
        this.getStepSettingsScript.bind(this),
        this,
      ],
      exit: [
        item,
        id,
        this.render.bind(this),
        this.exit.bind(this),
        this.error.bind(this),
        this.view.bind(this),
        this.onClickRedo.bind(this),
        this.again.bind(this),
        this.api.bind(this),
        this.populateValues.bind(this),
        this.getStepOptions.bind(this),
        this.validateAnswer.bind(this),
        this.getStepSettingsScript.bind(this),
        this,
      ],
    }

    var useRenderer = typeOf(item.type).toLowerCase() == 'object' ? item.type.use : item.type
    var element
    var naturalDelayConfig = this.getNaturalDelayConfig()
    switch (useRenderer) {
      case 'answer':
        element = new QreUserElement(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'again':
        element = new PanelAgain(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'autocomplete':
        element = new PanelAutoComplete(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'bot':
        if (this.executeResponseAction(item.str)) {
          this.setRenderedState(item)
          setTimeout(
            function () {
              this.playBot()
            }.bind(this),
            0
          )
          return
        } else {
          element = new QreBotElement(useArguments.default, naturalDelayConfig, this.variables)
        }
        break
      case 'button':
        var argumentsKey = item.next == 'exit' ? 'exit' : 'default'
        element = new PanelButton(useArguments[argumentsKey], naturalDelayConfig, this.variables)
        break
      case 'message':
        element = new PanelMessage(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'language_switch':
        element = new PanelLanguageSwitch(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'datetime':
        element = new PanelDatetime(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'ideal':
        element = new PanelIdeal(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'images':
        element = new PanelImages(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'mortgage':
        element = new PanelMortgage(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'pieslider':
        element = new PanelPieSlider(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'location':
        element = new PanelLocation(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'login':
        element = new PanelLogin(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'options':
        element = new PanelOptions(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'external_chat':
        element = new PanelExternalChat(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'rating':
        element = new PanelRate(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'text':
        element = new PanelText(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'yesno':
        element = new PanelYesNo(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'legal':
        element = new PanelLegal(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'text_autocomplete':
        element = new PanelTextAutoComplete(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'image_autocomplete':
        element = new PanelImageAutoComplete(useArguments.default, naturalDelayConfig, this.variables)
        break
      case 'file':
        element = new PanelFile(useArguments.default, naturalDelayConfig, this.variables)
        break
    }
    if (['bot', 'answer'].indexOf(useRenderer) < 0) {
      this.userAction('question', null, false)
    }

    this.setRenderedState(item)

    // Auto focus first element of question
    this.autoFocus(item)
    this.currentStepElement = element
    return element
  },
  autoFocus: function (item) {
    var _state = this._State,
      lastItem = _state.getLast(),
      prevItem = _state.length > 1 && _state[_state.length - 2],
      hasResponseBefore = prevItem ? prevItem.type === 'response' && prevItem.rendered.length > 0 : false,
      id = item.eid

    if (
      $(id) &&
      id === lastItem.rendered[0] &&
      lastItem.type !== 'answer' &&
      this.accessibilityMode &&
      !hasResponseBefore
    ) {
      setTimeout(function () {
        $(id)
          .set({
            tabindex: '-1',
            role: 'text',
          })
          .focus()
      }, 1000)
    }
  },
  _rendering: false,
  redoDisable: function () {
    var redoButtons = $$('.icon--redoWrapper')

    if (redoButtons.length) {
      redoButtons.toggleClass('disabled', this.isRendering)
    }
  },
  render: function (item, id, done, force, preset) {
    // Check if answer has no rendered question
    if (this._rendering && item.render) {
      return
    }

    this._rendering = true

    try {
      this.isRendering = !done ? true : false
      this.isRendering = force ? false : this.isRendering
      // this.redoDisable();

      if (!force) {
        if (this.redoActive && !done) {
          // if(this.isInStashedRedoElements(item)){
          //     this.redoPrompt(item.key);
          //     return;
          // }
        }
      }

      if (!done) {
        this.createElement(item, id)
        return
      }

      if (!force) {
        if ($(item.eid) || item.savedValue) {
          // it's been rendered and confirmed.

          // if it's a request that requires continuance.
          if (['bot', 'answer'].indexOf(item.type) >= 0) {
            var last = this._State
              .filter(function (item) {
                return item.key === item.key
              })
              .getLast()
            if (last && last.texts) {
              last.texts.append(this.getTexts({ rendered: [item.eid] }))
            }
            setTimeout(
              function () {
                this.playBot()
              }.bind(this),
              0
            )
          }
        } else {
          if (item) {
            if (item.type == 'answer') {
              // wait a bit, for natural responses.
              var timeout = preset ? 0 : this.getNaturalDelay()

              if (!item.eid) {
                item.eid = id
              }

              // requires no render
              this.setRenderedState(item)

              setTimeout(
                function () {
                  this.playBot()
                }.bind(this),
                timeout
              )
            } else {
              //it's not there, but it should be, so retry
              this.setRenderedState(item)
              setTimeout(
                function () {
                  this.playBot()
                }.bind(this),
                0
              )
            }
          }
        }
      }
    } finally {
      this._rendering = false
    }
  },
  update: function (item, id) {
    if (!$(id)) {
      this.render(item, id)
      return
    }
    $(id).fireEvent('update', item)
    if (!this.startedValidation) {
      setTimeout(
        function () {
          this.playBot()
        }.bind(this),
        0
      )
    }
  },
  events: function () {
    var parentBody = document.body
    this.app.addEvents({
      connMessage: function (msg) {
        this.connPut(msg)
      }.bind(this),
      fetchData: function (data) {
        var results = {}
        data.request.each(
          function (val) {
            results[val] = this[val].slice()
          }.bind(this)
        )

        data.resultsCallback(data.base, results)
      }.bind(this),
    })
  },
  initialize: function (quriobot) {
    this.store = quriobot.store
    window.quriobot = quriobot
    this.newConnection()
    this.getBotOptions(this.loadBot.bind(this))
  },
  init: function () {
    this.inputContainer = $('input--container')
    this.app = $('conversation')
    this.events()
    this.Environment = new Environment(this.connPut.bind(this), this.userAction.bind(this), this)
  },
})
